<template>
  <div class="countries">
    <base-select
      :select-options="options"
      v-bind="{ ...$attrs, ...$props }"
      :required="required"
      :name="name"
      @change="optionSelected"
    >
      <template #label>
        <slot name="label" />
      </template>
      <template #label-status>
        <slot name="label-status" />
      </template>
      <template #errorMessage>
        <slot name="errorMessage" />
      </template>
    </base-select>
  </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
/* TODO: Add proper typing to resolve type safety warnings */
import { Country } from '~/apps/countries/domain/types'
import { getUserCountry } from '~/utility/geo/geo-location'
import { Component, Prop, toNative, Vue } from '~/utility/pu-class-decorator'

interface SelectOption {
  name: string
  value: string
  selected?: boolean
}

@Component({
  emits: ['update:modelValue', 'change'],
  setup() {
    return { countriesStore: useCountriesStore() }
  },
})
class BaseCountry extends Vue {
  initialCountry = ''

  @Prop()
  modelValue!: string

  @Prop()
  name!: string

  @Prop()
  required: boolean

  async mounted() {
    this.initialCountry = this.modelValue || (await getUserCountry())
  }

  get selectedCountry() {
    return this.modelValue || this.initialCountry
  }

  get options() {
    const empty = [{ name: '---', value: '' }]
    return empty.concat(this.topCountries, empty, this.countries)
  }

  get topCountries() {
    return (
      this.countriesStore.countries
        .filter((c) => c.isTop)
        .sort((a, b) => a.order! - b.order!)
        .map(this.toOption) || []
    )
  }

  get countries() {
    return this.countriesStore?.countries.map(this.toOption) || []
  }

  toOption(country: Country): SelectOption {
    return {
      name: country.name,
      value: country.alpha2,
      selected: this.selectedCountry === country.alpha2,
    }
  }

  optionSelected(event) {
    this.$emit('update:modelValue', event.selectedValue)
  }
}

export default toNative(BaseCountry)
</script>

<style scoped>
.countries {
  margin-bottom: 0.75em;
  display: block;
}

.countries :deep(.select) {
  margin-left: 0;
  display: block;
}

.countries :deep(.select select) {
  font-size: 1.24em;
}
</style>
